import React              from 'react';
import { withRouter }     from 'react-router';
import { connect }        from 'react-redux';
import { Redirect }       from 'react-router-dom'
import { ClipLoader }     from 'react-spinners';
import * as Json          from './layouts/Json';
import * as Layouts       from './layouts/Layouts';
import lookup             from './Components';
import uuidv4             from '../utils/Uuid';
import { AwsConstants }   from '../utils/environment';
import { pageFetchData }  from '../actions/core/pages';

var apiHost = AwsConstants.WebApiHost;

class Dynamic extends React.Component {
    
  constructor(props) {
    super(props);
    this.state = {
      time: uuidv4()
    }
  }  
  
  componentDidMount() {
    this.unlisten = this.props.history.listen((location, action) => {
      const url     = location.pathname.toLowerCase();
      const tagName = (url.charAt(1).toUpperCase() + url.substr(2)).split('/')[0];
      if (!this.isLocal(tagName)) {
        this.props.fetchData(apiHost, { page: tagName }); 
      }
      else {
        this.setState({ time: uuidv4() });
      }
    });
    
    const tagName = this.tagName();
    if (!this.isLocal(tagName)) {
      this.props.fetchData(apiHost, { page: tagName });
    }
    else {
      this.setState({ time: uuidv4() });
    }
  }
  
  componentWillUnmount() {
    this.unlisten();
  }
  
  /*shouldComponentUpdate(nextProps, nextState) {
    const tagName = this.tagName();
    return !this.isLocal(tagName);
  }*/
  
  tagName() {
    var lower   = this.props.match.params.component.toLowerCase();
    var tagName = lower.charAt(0).toUpperCase() + lower.substr(1);
    return tagName;
  }
  
  isLocal(tagName) {
    return Json[lookup(tagName)] && Layouts[Json[lookup(tagName)].name];
  }

  render() {
    const tagName = this.tagName();
    const Component = this.isLocal(tagName) ? Layouts[Json[lookup(tagName)].name] : null;
    if (!Component) {
      if (this.props.isLoading) {
        return (
          <div style={{ marginRight: 'auto', marginLeft: 'auto', width: '5em' }}>
            <ClipLoader
              color={'#072659'} 
              loading={this.props.isLoading}
              size={60}
            />
          </div>
        );
      }
      else if (!this.props.isLoading && !this.props.hasErrored) {
        const DynamicComponent = Layouts[this.props.page.name];
        return (
          <div>
            {DynamicComponent && <DynamicComponent key={this.state.time} map={this.props.page.map} />}
          </div>
        );
      }
      else if (this.props.hasErrored) {
        return <Redirect to='/404' />;  
      }
    }
    else {
      return (
        <div>
          {Component && <Component key={this.state.time} map={Json[lookup(tagName)].map} />}
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    page: state.core.pages.page,
    hasErrored: state.core.pages.pageHasErrored,
    isLoading: state.core.pages.pageIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (host, params) => dispatch(pageFetchData(host, params))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dynamic));
